// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as CSS$MakerDs from "maker-ds/src/CSS.bs.mjs";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Alert$MakerDs from "maker-ds/src/Alert.bs.mjs";
import * as Clerk$FeedSync from "./frontend/Clerk.bs.mjs";
import * as Loader$MakerDs from "maker-ds/src/Loader.bs.mjs";
import * as Location$FeedSync from "./frontend/Location.bs.mjs";
import * as UrlUtils$FeedSync from "./frontend/UrlUtils.bs.mjs";
import * as ClerkReact from "@clerk/clerk-react";

function AuthScreen$ChildrenOrRedirect(Props) {
  var children = Props.children;
  React.useEffect((function () {
          if (Belt_Option.isNone(children)) {
            Location$FeedSync.goTo(undefined, undefined, undefined, undefined, []);
          }
          
        }), [Belt_Option.isNone(children)]);
  return Belt_Option.getWithDefault(children, null);
}

var ChildrenOrRedirect = {
  make: AuthScreen$ChildrenOrRedirect
};

var refreshPage = (function() {
      window.location.reload()
    });

function AuthScreen$RequireOrganizationScreen(Props) {
  var children = Props.children;
  var match = Clerk$FeedSync.useOrganization(undefined);
  var match$1 = ClerkReact.useOrganizationList();
  var setActive = match$1.setActive;
  var organization = Caml_option.nullable_to_opt(match.organization);
  var match$2 = Belt_Option.flatMap(organization, (function (org) {
          return org.publicMetadata.accountId;
        }));
  var organization$1 = match$2 !== undefined ? organization : undefined;
  var firstAvailableOrganization = Belt_Option.flatMap(Belt_Option.map(match$1.organizationList, (function (orgs) {
              return Belt_Array.keep(orgs, (function (org) {
                            return Belt_Option.isSome(org.organization.publicMetadata.accountId);
                          }));
            })), (function (orgs) {
          return Belt_Array.get(orgs, 0);
        }));
  var allLoaded = match.isLoaded && match$1.isLoaded;
  var activate = organization$1 !== undefined || firstAvailableOrganization === undefined ? undefined : firstAvailableOrganization.organization;
  var alreadyActive = activate !== undefined && organization$1 !== undefined ? organization$1.id === activate.id : false;
  var autoActivateExistingOrganization = alreadyActive ? undefined : activate;
  var nextStep = allLoaded ? (
      autoActivateExistingOrganization !== undefined ? /* Activate */({
            _0: autoActivateExistingOrganization
          }) : /* Nothing */1
    ) : /* Loading */0;
  var match$3 = React.useState(function () {
        
      });
  var error = match$3[0];
  React.useEffect((function () {
          if (typeof nextStep === "number") {
            
          } else {
            Curry._1(setActive, {
                  organization: nextStep._0
                });
          }
        }), [nextStep]);
  var renderLoader = function (element) {
    return React.createElement("div", {
                className: CSS$MakerDs.prefix("flex flex-col items-center justify-center gap-3 w-full h-screen text-gray-500")
              }, React.createElement("div", {
                    className: CSS$MakerDs.prefix("h-5")
                  }, React.createElement(Loader$MakerDs.make, {
                        msDelay: 0
                      })), error !== undefined ? React.createElement(Alert$MakerDs.make, {
                      children: error
                    }) : element);
  };
  var orgId = Belt_Option.map(organization$1, (function (organization) {
          return organization.id;
        }));
  if (typeof nextStep === "number") {
    if (nextStep === 0) {
      return renderLoader(React.createElement("div", undefined, "Loading..."));
    }
    var tmp = {};
    if (orgId !== undefined) {
      tmp.key = Caml_option.valFromOption(orgId);
    }
    return React.createElement("div", tmp, children);
  }
  var name = nextStep._0.name;
  return renderLoader(React.createElement("div", undefined, "Switching to " + (
                  name !== undefined ? "the " + name + " organization" : "your organization"
                ) + ". Please wait..."));
}

var RequireOrganizationScreen = {
  refreshPage: refreshPage,
  make: AuthScreen$RequireOrganizationScreen
};

function AuthScreen(Props) {
  var children = Props.children;
  if (Belt_Option.isNone((window.ENV.accessToken == null) ? undefined : Caml_option.some(window.ENV.accessToken))) {
    var tmp = {};
    if (children !== undefined) {
      tmp.children = Caml_option.valFromOption(children);
    }
    return React.createElement(Clerk$FeedSync.Provider.make, {
                children: null
              }, React.createElement(ClerkReact.SignedIn, {
                    children: React.createElement(AuthScreen$RequireOrganizationScreen, {
                          children: React.createElement(AuthScreen$ChildrenOrRedirect, tmp)
                        })
                  }), React.createElement(ClerkReact.SignedOut, {
                    children: React.createElement("div", {
                          className: CSS$MakerDs.prefix("flex h-screen justify-center items-center")
                        }, React.createElement(ClerkReact.SignIn, {
                              redirectUrl: UrlUtils$FeedSync.getCurrentUrl(undefined)
                            }))
                  }));
  }
  var tmp$1 = {};
  if (children !== undefined) {
    tmp$1.children = Caml_option.valFromOption(children);
  }
  return React.createElement(AuthScreen$ChildrenOrRedirect, tmp$1);
}

var make = AuthScreen;

export {
  ChildrenOrRedirect ,
  RequireOrganizationScreen ,
  make ,
}
/* react Not a pure module */
